import { render } from "./CustomersTable.vue?vue&type=template&id=e2787fc2&scoped=true"
import script from "./CustomersTable.vue?vue&type=script&lang=js"
export * from "./CustomersTable.vue?vue&type=script&lang=js"

import "./CustomersTable.vue?vue&type=style&index=0&id=e2787fc2&lang=scss&scoped=true"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2787fc2"]])

export default __exports__